import React from 'react';
import ElementorButton from './ElementorButton';

interface StepProps {
    onNextClick: () => void;
    onPrevClick?: () => void;
    prevText?: string;
    nextText: string;
    showPrev?: boolean;
    submitFullWidth?: boolean;
    header?: React.ReactNode;
}

const Step: React.FC<StepProps> = (props) => {
    const { header, onPrevClick = () => {}, onNextClick, prevText, nextText, submitFullWidth = false, showPrev = false, children } = props;

    return (
        <div className="section-container">
            {header && <div className="section-spacer header">{header}</div>}
            <div className="section-spacer">
                <div className="info-block">{children}</div>
                <div className={`step-actions ${showPrev ? 'flex-between' : ''}`}>
                    {showPrev && (
                        <ElementorButton className="bordered-btn" onClick={onPrevClick}>
                            {prevText}
                        </ElementorButton>
                    )}
                    <ElementorButton className={submitFullWidth ? 'btn-w-full' : ''} onClick={onNextClick}>
                        {nextText}
                    </ElementorButton>
                </div>
            </div>
        </div>
    );
};

export default Step;
